import { PureComponent } from 'react';
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid/Grid';
import { connect } from 'react-redux';

import Attachment from '../components/Attachment';
import FormGroup from 'Components/FormGroup/FormGroup';
import { aclDecorator } from 'Decorators';
import { loadAttachmentsData } from 'Actions/submission';
import {
    FILE_TYPE_MANUSCRIPT,
    FILE_ACCEPT_MANUSCRIPT,
    FILE_TYPE_COVER_LETTER,
    FILE_ACCEPT_COVER_LETTER,
    FILE_TYPE_PERMISSION,
    FILE_ACCEPT_PERMISSION,
    FILE_TYPE_REVIEW,
    FILE_ACCEPT_REVIEW,
    FILE_TYPE_MANUSCRIPT_BLIND,
    FILE_ACCEPT_MANUSCRIPT_BLIND,
    ROLE_EDITORIAL_BOARD,
    ROLE_REVIEWER,
    ROLE_AUTHOR,
    PROCESS_STATUS_AUTHOR_REVISION,
    PROCESS_STATUS_REJECTED,
    PROCESS_STATUS_PUBLISHED,
    ROLE_EDITOR,
    PHASE_PLAGIARISM_CHECK,
    PHASE_PEER_REVIEW,
    ASSIGN_STATUS_ACCEPTED,
    PHASE_INITIAL_REVIEW,
} from 'Constants';
import Badge from 'Common/Badge/Badge';

@aclDecorator()
@connect(store => ({
    filter: store.submissionAttachments.filter,
    attachments: store.submissionAttachments.attachments,
    userId: store.auth.user.id,
}), dispatch => ({
    loadAttachmentsData: (filter, isReviewer) => dispatch(loadAttachmentsData(filter, isReviewer)),
}))
export default class Attachments extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        submissionData: PropTypes.object.isRequired,
        isOneOf: PropTypes.func.isRequired,
        is: PropTypes.func.isRequired,
        loadAttachmentsData: PropTypes.func.isRequired,
        filter: PropTypes.object,
        attachments: PropTypes.object,
        userId: PropTypes.number,
        onFileUpload: PropTypes.func.isRequired,
    };

    componentDidMount() {
        const { loadAttachmentsData, submissionData: { id }, filter, isOneOf } = this.props;
        const types = this.getAllowedTypes(true);

        loadAttachmentsData(filter.merge({
            where: {'type': {inq: types.map(type => type.type)}},
            has: {'submission': {
                where: {'submissions.id': id},
            }}
        }), isOneOf([ROLE_REVIEWER, ROLE_EDITORIAL_BOARD]) ? 1 : 0);
    }

    isOnRevision() {
        const { submissionData: { process_status } } = this.props;
        return process_status === PROCESS_STATUS_AUTHOR_REVISION;
    }

    isActiveProcess() {
        const { submissionData: { process_status } } = this.props;
        return ![PROCESS_STATUS_REJECTED, PROCESS_STATUS_PUBLISHED].includes(process_status);
    }

    getAllowedTypes(isLoad = false) {
        const { is, isOneOf, submissionData: { status: { alias }, reviewers, is_reviewed }, userId, attachments } = this.props;
        let types = [];

        if (!isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER])) {
            types.push({
                type: FILE_TYPE_MANUSCRIPT, accept: FILE_ACCEPT_MANUSCRIPT,
                upload: this.isActiveProcess() && !is(ROLE_EDITOR) && (!is(ROLE_AUTHOR) || this.isOnRevision())
            });
        }

        if (isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER])) {
            types.push({
                type: FILE_TYPE_MANUSCRIPT_BLIND, accept: FILE_ACCEPT_MANUSCRIPT_BLIND,
                upload: false
            });
        }

        if (!isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER])) {
            types.push({
                type: FILE_TYPE_COVER_LETTER, accept: FILE_ACCEPT_COVER_LETTER,
                upload: this.isActiveProcess() && !is(ROLE_EDITOR) && (!is(ROLE_AUTHOR) || this.isOnRevision())
            });
        }

        if (!isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER]) &&
            (isLoad || ([PHASE_PLAGIARISM_CHECK, PHASE_INITIAL_REVIEW].includes(alias) && is(ROLE_AUTHOR) && this.isOnRevision())
                || (attachments && attachments[FILE_TYPE_PERMISSION]))) {

            types.push({
                type: FILE_TYPE_PERMISSION, accept: FILE_ACCEPT_PERMISSION,
                upload: this.isActiveProcess() && is(ROLE_AUTHOR) && this.isOnRevision() && ([PHASE_PLAGIARISM_CHECK, PHASE_INITIAL_REVIEW].includes(alias)),
            });
        }

        if (reviewers && isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER]) && (alias === PHASE_PEER_REVIEW)) {
            const userAssignations = reviewers.filter(reviewer => (reviewer.user_id === userId && reviewer.status === ASSIGN_STATUS_ACCEPTED));
            if (userAssignations.length) {
                types.push({
                    type: FILE_TYPE_REVIEW, accept: FILE_ACCEPT_REVIEW,
                    upload: this.isActiveProcess() && !is_reviewed,
                    round: userAssignations[userAssignations.length - 1].submission_review_round_id
                });
            }
        }

        if (!isOneOf([ROLE_AUTHOR, ROLE_EDITORIAL_BOARD, ROLE_REVIEWER])) {
            types.push({
                type: FILE_TYPE_MANUSCRIPT_BLIND, accept: FILE_ACCEPT_MANUSCRIPT_BLIND,
                upload: this.isActiveProcess() && !is(ROLE_EDITOR)
            });
        }

        return types;
    }

    render () {
        const { submissionData: { id }, attachments, isOneOf, onFileUpload } = this.props;
        const types = this.getAllowedTypes();
        const hasManuscriptForReview = !!types.find(type => type.type === FILE_TYPE_MANUSCRIPT_BLIND) && !isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER]);

        return (
            <Grid container spacing={24}>
                {types.map((type, key) => {
                    const isBlind = type.type === FILE_TYPE_MANUSCRIPT_BLIND;
                    const typesInGridCount = isBlind && hasManuscriptForReview ? 1 : (hasManuscriptForReview ? (types.length - 1) : types.length);

                    return (
                        <Grid
                            item
                            xs={12 / typesInGridCount}
                            key={key}
                            className={isBlind && !isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER]) ? 'blind-manuscript-attach-wrapper' : ''}
                        >
                            <FormGroup
                                title={`field.attach.${type.type}.label`}
                                customClass={type.isOneTimeOperation && !attachments[type.type] ? 'form-grouper-one-time-wrapper' : ''}
                                customTitleBlock={
                                    isBlind && !isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER]) ?
                                        <span className='mfr-label'><Badge color='danger'>Required</Badge></span> :
                                        null
                                }
                            >
                                <div className="info-wrapper-file">
                                    <Attachment
                                        submissionId={id}
                                        attachments={attachments}
                                        onFileUpload={onFileUpload}
                                        {...type}
                                    />
                                </div>
                            </FormGroup>
                        </Grid>
                    );
                })}
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/containers/Attachments.jsx